import React, { useContext } from "react";
import { Link } from "react-router-dom";
import '../style/body-style.css'
import LanguageContext from "./LanguageContext";
import CK_en from '../resources/CK_en.json';
import CK_fr from '../resources/CK_fr.json';


function Header() {
    const { language, toggleLanguage } = useContext(LanguageContext);
    const CK = language === 'en' ? CK_en : CK_fr;
    
    const buttonAbbr = language === 'en' ? 'FR' : 'EN';

    return (
            <header className="ontario-header" id="ontario-header-default" style={{display : 'inline-table', height: '3.125rem'}}>
                <div className="ontario-row ontario-header__first-row"  style={{overflow: 'visible',height:'3.125rem', alignItems: 'center', padding: '0 1rem'}}>
                    <div className="ontario-header__logo-container ontario-small-6">
                        <h1 style={{ display: 'inline', margin: 0 }}>
                            <a href="https://www.ontario.ca/page/government-ontario">
                            <img className="ontario-logo" style={{ width: '6.25rem', height: '1.5625rem' }} src="assets/logos/ontario-logo--desktop.svg" alt="Government of Ontario" />
                            </a>
                        </h1>
                    </div>
                    <div className="ontario-header__nav-right-container ontario-small-6" style={{ padding: '1.55rem' }}>
                        <button onClick={toggleLanguage} className="ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline">
                            <abbr title={CK["header.otherlang.display"]} className="ontario-show-for-small-only">
                            {buttonAbbr}
                            </abbr>
                            <span className="ontario-show-for-medium" style={{ fontSize: '1rem', fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif', fontWeight: '600', lineHeight: '1.375rem' }}>
                            {CK["header.otherlang.display"]}
                            </span>
                        </button>
                    </div>
                </div>
                <div className='ontario-service-subheader-menu__container'>
                    <div className="ontario-header__second-row" style={{ backgroundColor: '#03713d', padding: '1rem 0' }}>
                        <div className="ontario-row">
                            <span style={{ fontFamily: '"Raleway", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif', fontSize: '1.75rem', fontWeight: '700', letterSpacing: '0.02rem', lineHeight: '1.43', color: '#fff', margin: 0 }} tabIndex="0">ServiceOntario</span>
                        </div>
                    </div>
                </div>
            </header>

    );
}

export default Header;
